import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import JiveBirdTemp from "./components";


const App = () => {
	return (
		<Router>
			<Switch>
				<Route path="/:id" exact component={JiveBirdTemp} />
			</Switch>
		</Router>
	);
};

export default App;



  
